export const TILE_SIZE = 64;          // pixels per tile edge
export const WORLD_SCALE = 30;         // world units per pixel
export const MAX_HEIGHT = 1440;        // max world height
export const TILE_WORLD = TILE_SIZE * WORLD_SCALE; // world units per tile

export const PLAYER_RADIUS = 1.0;
export const GRAVITY = 9.81;           // m/s^2 (real)
export const THROTTLE_ACCEL = 20.0;    // input acceleration along heading
export const BRAKE_DECEL = 40.0;       // braking deceleration
export const TURN_RATE = 2.6;          // max steering rate (rad/s)
export const AIR_CONTROL = 0.35;       // fraction of throttle/steer usable in air
export const MAX_SPEED = 277.78;       // powered top speed (~1000 km/h); gravity may exceed it
export const RESTITUTION = 0.15;       // ground bounce (low = rolls, doesn't hop)
export const ROLL_RESIST = 2.2;        // rolling-friction deceleration (m/s^2)
export const GROUND_SNAP = 0.8;        // tolerance above surface still treated grounded
export const JUMP_VELOCITY = 11.0;
export const NORMAL_DELTA = 32.0;      // world units between normal samples (~1 heightmap px)
export const PHYSICS_HZ = 120;         // fixed integration rate

export const CAMERA_DISTANCE = 24.0;
export const CAMERA_HEIGHT = 11.0;
export const CAMERA_LOOK = 3.0;        // look this far above the ball
export const CAMERA_SMOOTH = 6.0;      // follow responsiveness
export const CAMERA_MIN_ABOVE_TERRAIN = 3.0;

export const LOAD_RADIUS = 4;          // tiles to load around player
export const UNLOAD_RADIUS = 6;        // tiles to keep loaded
export const TILE_SEGMENTS = 64;       // mesh segments per tile edge
export const LOD_DISTANCES = [0, 1, 2, 4]; // tile distances for LOD levels
export const LOD_SEGMENTS = [64, 32, 16, 8]; // mesh segments per LOD
